import {
    IAppActions as IAppActionsBase,
    ISetShowProgressAction as ISetShowProgressActionBase
} from './app-actions';
import { appInitialState, appReducer } from './app-reducer';
import {
    ISessionActions as ISessionActionsBase,
    ISetLastActivityAction as ISetLastActivityActionBase
} from './session-actions';
import { sessionInitialState, sessionReducer } from './session-reducer';
import { IAppState, ISessionState } from './state';

export { AppActionType } from './app-actions';
export { SessionActionType } from './session-actions';

export type IAppActions = IAppActionsBase;
export type ISetShowProgressAction = ISetShowProgressActionBase;

export type ISessionActions = ISessionActionsBase;
export type ISetLastActivityAction = ISetLastActivityActionBase;

export const reducers = {
    app: appReducer,
    session: sessionReducer
};

export interface ICoreState {
    app: IAppState;
    session: ISessionState;
}

// App
export const getAppState = (state: ICoreState): IAppState => state.app || appInitialState;

export const getAppProgress = (state: ICoreState): boolean => {
    const appState = getAppState(state);
    return appState.progress;
};

export const getAppProgressText = (state: ICoreState): string => {
    const appState = getAppState(state);
    return appState.progressText || 'Please wait';
};

export const getAppRedirect = (state: ICoreState): string => {
    const appState = getAppState(state);
    return appState.redirect;
};

// Session
export const getSessionState = (state: ICoreState): ISessionState =>
    state.session || sessionInitialState;

export const getLastActivity = (state: ICoreState): Date => {
    const sessionState = getSessionState(state);
    return sessionState.lastActivity;
};
